// MUI
import { Skeleton, Stack } from "@mui/material";

// Components
import TableLoader from "@Layouts/components/Skeletons/TableLoader";

export function CITDealsTableSectionSkeleton() {
	return (
		<Stack spacing={4}>
			<Skeleton variant={"text"} width={700} height={50} />
			<TableLoader toolbar buttons={3} content rows={7} multiTitles={5} />
		</Stack>
	);
}
